import React from 'react';
import Icon from '../../../components/AppIcon';

const ContributionHistoryTable = ({ contributions }) => {
  if (contributions?.length === 0) {
    return (
      <div className="bg-card rounded-lg p-24 text-center">
        <Icon name="DollarSign" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-12" />
        <p className="text-muted-foreground">No contributions recorded yet</p>
        <p className="text-sm text-muted-foreground mt-8">Contributions will appear here automatically when transactions are made to the linked account</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden">
      {/* Desktop view */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-16 py-12 text-left text-sm font-semibold text-foreground">Date</th>
              <th className="px-16 py-12 text-left text-sm font-semibold text-foreground">Amount</th>
              <th className="px-16 py-12 text-left text-sm font-semibold text-foreground">Source</th>
              <th className="px-16 py-12 text-left text-sm font-semibold text-foreground">Notes</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {contributions?.map((contribution) => (
              <tr key={contribution?.id} className="hover:bg-muted/50 transition-smooth">
                <td className="px-16 py-16 text-sm text-foreground">
                  {new Date(contribution?.contributionDate)?.toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </td>
                <td className="px-16 py-16 text-sm font-semibold text-success">
                  +${contribution?.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="px-16 py-16 text-sm">
                  {contribution?.isAutomatic ? (
                    <div className="flex items-center gap-8">
                      <Icon name="Zap" size={16} color="var(--color-primary)" />
                      <span className="text-primary font-medium">Automatic</span>
                    </div>
                  ) : (
                    <div className="flex items-center gap-8">
                      <Icon name="User" size={16} color="var(--color-muted-foreground)" />
                      <span className="text-muted-foreground">Manual</span>
                    </div>
                  )}
                </td>
                <td className="px-16 py-16 text-sm text-muted-foreground">
                  {contribution?.transaction ? (
                    <div>
                      <div className="font-medium text-foreground">{contribution?.transaction?.description}</div>
                      <div className="text-xs text-muted-foreground mt-4">From transaction</div>
                    </div>
                  ) : (
                    contribution?.notes || '-'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile view - stacked cards */}
      <div className="md:hidden divide-y divide-border">
        {contributions?.map((contribution) => (
          <div key={contribution?.id} className="p-16 hover:bg-muted/50 transition-smooth">
            <div className="flex items-start justify-between mb-12">
              <div className="flex-1">
                <div className="text-sm text-muted-foreground mb-4">
                  {new Date(contribution?.contributionDate)?.toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </div>
                <div className="text-lg font-semibold text-success">
                  +${contribution?.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </div>
              <div>
                {contribution?.isAutomatic ? (
                  <div className="flex items-center gap-6 px-10 py-6 bg-primary/10 rounded-lg">
                    <Icon name="Zap" size={14} color="var(--color-primary)" />
                    <span className="text-xs text-primary font-medium">Auto</span>
                  </div>
                ) : (
                  <div className="flex items-center gap-6 px-10 py-6 bg-muted rounded-lg">
                    <Icon name="User" size={14} color="var(--color-muted-foreground)" />
                    <span className="text-xs text-muted-foreground font-medium">Manual</span>
                  </div>
                )}
              </div>
            </div>
            <div className="text-sm text-muted-foreground">
              {contribution?.transaction ? (
                <div>
                  <div className="font-medium text-foreground">{contribution?.transaction?.description}</div>
                  <div className="text-xs text-muted-foreground mt-4">From transaction</div>
                </div>
              ) : (
                contribution?.notes || 'No notes'
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContributionHistoryTable;